import { FC } from 'react';

import { AnimatePresence } from 'framer-motion';

import { VStack } from '@ui-furniture/elements';
import { x } from '@ui-furniture/style';

import { EndOfMessages } from './end-of-messages';
import { MessageGroup } from './message-group';
import { RestoreContainer } from './restore-container';
import { TypingAnimation } from './typing-animation';

import { useGroupedMessages } from '../hooks/use-grouped-messages';
import { useScrollToEndOfMessages } from '../hooks/use-scroll-to-end-of-messages';
import { Message } from '../types/message';

const scrollContainerId = 'scroll-container';
const endOfMessagesId = 'messages-end';

export const MessagesArea: FC<{
  isTyping: boolean;
  isEditing: boolean;
  messages: Array<Message>;
}> = ({ isTyping, isEditing, messages }) => {
  useScrollToEndOfMessages({
    elementId: endOfMessagesId,
    messages,
    containerId: scrollContainerId,
  });
  const groupedMessages = useGroupedMessages(messages);
  return (
    <x.div
      id={scrollContainerId}
      bg='brand-white'
      borderRadius='lg'
      border='1px solid'
      borderColor='brand-beige'
      p='md'
      w='100%'
      maxH='100%'
      overflowY='auto'
      overflowX='hidden'
    >
      <VStack spacing='md'>
        <AnimatePresence>
          {groupedMessages.map((messageGroup, groupIndex) => {
            switch (messageGroup.side) {
              case 'right':
                return (
                  <RestoreContainer
                    // eslint-disable-next-line react/no-array-index-key
                    key={groupIndex}
                    isEditing={isEditing}
                    restore={messageGroup.restore}
                  >
                    <MessageGroup {...messageGroup} />
                  </RestoreContainer>
                );
              case 'left':
                return (
                  <MessageGroup
                    // eslint-disable-next-line react/no-array-index-key
                    key={groupIndex}
                    {...messageGroup}
                  />
                );
              default:
                throw new Error(`Unrecoginsed side`);
            }
          })}
        </AnimatePresence>
        <TypingAnimation isActive={isTyping} />
      </VStack>
      <EndOfMessages id={endOfMessagesId} />
    </x.div>
  );
};
